import { AfterViewInit, Component, OnDestroy, OnInit,  } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';
import { ExportgridComponent } from 'src/app/components/grid/exportgrid/exportgrid.component';
import { AddlpoComponent } from './addlpo/addlpo.component';
@Component({
  selector: 'app-lpo',
  templateUrl: './lpo.component.html',
  styleUrls: ['./lpo.component.css']
})
export class LpoComponent implements OnInit, AfterViewInit, OnDestroy {


  lpoColl: any = [];

  partyColl: any = [];

  filterColl: any = [];

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;

  istableloading: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Lpo";
  filterstatus: any = "UNPOSTED"

  filterpartyid: number = null;
  filterfromdate: any = new Date();
  filtertodate: any = new Date();
  filtersearchtxt: any = "";

  searchtxt: any = "";
  columnDefs = [     
    { headerName: 'Lpo No', field: 'lpono' },
    { headerName: 'Date', field: 'lpodate', type: 'date' },
    { headerName: 'Supplier', field: 'partyname' },
    { headerName: 'PaymentMode', field: 'paymentmodename' },
    { headerName: 'Invoice No', field: 'refno' },
    { headerName: 'Description', field: 'descr' },
    { headerName: 'Grand Total', field: 'grandtotal',type: 'decimal' }, 
    { headerName: 'Status', field: 'postingstatus', type: 'activestatus' },  
  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
  };

 
 

  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal, private route: ActivatedRoute, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService) {
    this.fnGetParameterVariable();
    this.fnServiceChanges();

    this.filterfromdate.setDate(this.filterfromdate.getDate() - 15);
  }

  fnGetParameterVariable() {
    // this.route.queryParams.subscribe(params => {
    //   if (params.partyid !== undefined) {
    //     this.filterpartyid = params.partyid
    //   }
    // })
  }
  //User Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
         
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {

    this.fngetParty();
    this.fngetLpoListview()

    this.fnGetFilterStatus()
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  ngAfterViewInit(): void {
  
  }

  ngOnDestroy(): void {
  
  }


  fnGetFilterStatus() {
    this.filterColl = []    
    this.filterColl.push({ value: 'UNPOSTED', displayname: 'Unposted' });
    this.filterColl.push({ value: 'POSTED', displayname: 'Posted' });
    this.filterColl.push({ value: 'ALL', displayname: 'All' });
    this.filterColl.push({ value: 'CANCELLED', displayname: 'Cancelled' });
  }


  fngetParty() {
    var data = {
      'partyid': 0,
      'ptype': 'S',
      'companyid': this.loginService.fnGetCompanyId()       

    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.partyColl = res.json().result;

            this.fngetLpoListview();
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetLpoListview() {

    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {
      'lpoid': 0,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'partyid': this.filterpartyid,
      'companyid': this.loginService.fnGetCompanyId(),       
      'filterstatus': this.filterstatus
    }
    this.appService.getLpoByListview(data)
      .subscribe(
        (res) => {

          this.fnHideProgress();
          if (res.json().status == 200) {
            this.lpoColl = res.json().result;

            this.fnSetDataTable();
          }
          else if (res.json().status == 400) {
            this.toastr.error('Error', res.json().err_field);
          }


        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }


  fnAddLpo() {
    try {
      const modalRef = this.productFindService.open(AddlpoComponent,{ size: <any>'xxl', backdrop: 'static',keyboard: false  });

      modalRef.componentInstance.filterpartyid = this.filterpartyid;
      modalRef.componentInstance.filterfromdate = this.filterfromdate;
      modalRef.componentInstance.filtertodate = this.filtertodate;
      modalRef.componentInstance.ngOnInit();

      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetLpoListview();

      });


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnEditLpo(pBO) {
    try {
      var deptid = pBO.lpoid
      var mode=pBO.modetype
      if (!this.isedit) {
        return;
      }
      const modalRef = this.productFindService.open(AddlpoComponent, { size: <any>'xxl', backdrop: 'static',keyboard: false  });
      modalRef.componentInstance.lpoid = deptid;
      modalRef.componentInstance.filterpartyid = this.filterpartyid;
      modalRef.componentInstance.filterfromdate = this.filterfromdate;
      modalRef.componentInstance.filtertodate = this.filtertodate;
      modalRef.componentInstance.formmode = "EDIT";
      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetLpoListview();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  
  fnViewLpo(pBO) {
    try {
      var deptid = pBO.lpoid
      var mode=pBO.modetype
      if (!this.isview) {
        return;
      }
      const modalRef = this.productFindService.open(AddlpoComponent, { size: <any>'xxl', backdrop: 'static',keyboard: false  });
      modalRef.componentInstance.lpoid = deptid;
      modalRef.componentInstance.filterpartyid = this.filterpartyid;
      modalRef.componentInstance.filterfromdate = this.filterfromdate;
      modalRef.componentInstance.filtertodate = this.filtertodate;
      modalRef.componentInstance.formmode = "VIEW";
      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetLpoListview();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }




  public fnDeleteConfirm(pBO) {
    try {
      var deptid = pBO.lpoid

      if (!this.isdelete) {
        return;
      }

      
      if (pBO.isposted === 1) {
        return;
      }        
      
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete lpo?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteLpo(deptid)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteLpo(deptid) {
    var data = {
      'lpoid': deptid,
    }
    this.appService.fnDeleteLpo(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.toastr.success('', " The lpo has been deleted successfully.");

            this.fnInsertActivityLog('DELETE', deptid, this.fnGetDescription(deptid));

            this.fngetLpoListview();
          } else {
            this.toastr.error('', res.json().err_field);
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnCurrentRouteChange() {
    var queryParams = {};



    if (this.filterpartyid > 0) {
      queryParams['partyid'] = this.filterpartyid;
    }



    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }


  private fnSetDataTable() {
  
  }


  fnPrintData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnExportData() {
    try {


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

 
  fnGetDescription(id) {
    const index = this.lpoColl.findIndex(sku => sku.lpoid === id);

    if (index) {
      return this.lpoColl[index].taxgroupname;
    }
    else {
      return "";
    }

  }
  
  fnActionExportClick()  {
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.lpoColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  }


    fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId()       

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{

        });

    } catch {

    }
  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//hh:mm a  
    }
    else {
      return '';
    }
  }

  fnMomentDateTimeFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY hh:mm a');//  
    }
    else {
      return '';
    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }


  fnChangeFoc(){
    document.querySelector('.ng-input input').parentElement.blur();
  }



}
